import $ from 'jquery';
import { fabric } from 'fabric';
import { messageUtility } from '../../utilities/messageUtility';
import { ui } from './ui';
import * as pdfjs from 'pdfjs-dist/es5/build/pdf';
import pdfjsWorker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

function CropperImage() {
  this.croppedDataUrl = '';
  const MAX_WIDTH_CROPPED_CANVAS = 560;
  const MAX_HEIGHT_CROPPED_CANVAS = 396;
  const MAX_WIDTH_CROPPED_CANVAS_AVATAR = 576;
  const MAX_HEIGHT_CROPPED_CANVAS_AVATAR = 416;
  const TOP_LEFT_OFFSET = 8;
  this.createLayerObjects = function(img, scale, topLeftOffset, isSetAvatar) {
    const layerObjs = {};
    // use this rectangle to select the area which will be the cropped image
    const isHorizontal = img.width > img.height;
    const rectSize = isHorizontal ? img.height * scale : img.width * scale;
    const cropRect = new fabric.Rect({
      type: 'crop-rect',
      top: topLeftOffset,
      left: topLeftOffset,
      width: isSetAvatar ? rectSize : img.width * scale,
      height: isSetAvatar ? rectSize : img.height * scale,
      originX: 'left',
      originY: 'top',
      dirty: true,
      opacity: 1,
      borderColor: '#E64E17',
      selectable: true,
      stroke: '#E64E17',
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 2,
      strokeUniform: true,
      strokeDashArray: [5, 5],
      hasBorders: false,
      cornerColor: '#E64E17',
      cornerStrokeColor: '#E64E17',
      transparentCorners: false,
      hasRotatingPoint: false,
      cornerSize: 12,
      excludeFromExport: true,
    });
    // the overlay gray rectangle
    const overlayRect = new fabric.Rect({
      type: 'overlay',
      fill: '#7C7C7C',
      left: topLeftOffset,
      top: topLeftOffset,
      width: img.width * scale - 1,
      height: img.height * scale - 1,
      originX: 'left',
      originY: 'top',
      stroke: '#ccc',
      opacity: 0.9,
      hasRotatingPoint: false,
      selectable: false,
      objectCaching: false,
    });
    if (isSetAvatar) {
      cropRect.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      });
      overlayRect.set({
        fill: '#000',
        opacity: 0.5,
      });
    }
    layerObjs.cropped_rect = cropRect;
    layerObjs.overlay_rect = overlayRect;
    return layerObjs;
  };

  this.initCrop = function(
    fabricCanvasBg,
    bg,
    originalWidth,
    originalHeight,
    originalBg = false,
    originalScale = 1,
    isSetAvatar = false,
    originalFileType
  ) {
    let self = this;
    const MAX_WIDTH = isSetAvatar
      ? MAX_WIDTH_CROPPED_CANVAS_AVATAR - TOP_LEFT_OFFSET * 2
      : MAX_WIDTH_CROPPED_CANVAS - TOP_LEFT_OFFSET * 2;
    const MAX_HEIGHT = isSetAvatar
      ? MAX_HEIGHT_CROPPED_CANVAS_AVATAR - TOP_LEFT_OFFSET * 2
      : MAX_HEIGHT_CROPPED_CANVAS - TOP_LEFT_OFFSET * 2;
    fabric.EgImage.fromURL(originalBg || bg, function(img) {
      let scale = 1;
      // scale if width > MAX_WIDTH or height > MAX_HEIGHT
      if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
        scale =
          MAX_WIDTH / img.width < MAX_HEIGHT / img.height
            ? MAX_WIDTH / img.width
            : MAX_HEIGHT / img.height;
      }

      img.set({
        top: TOP_LEFT_OFFSET,
        left: TOP_LEFT_OFFSET,
        scaleX: scale,
        scaleY: scale,
        selectable: false,
        dirty: true,
      });
      const layerObjs = self.createLayerObjects(
        img,
        scale,
        TOP_LEFT_OFFSET,
        isSetAvatar
      );
      const overlayRect = layerObjs.overlay_rect;
      const cropRect = layerObjs.cropped_rect;
      cropRect.saveState();
      fabricCanvasBg.setWidth(img.width * scale + TOP_LEFT_OFFSET * 2);
      fabricCanvasBg.setHeight(img.height * scale + TOP_LEFT_OFFSET * 2);
      fabricCanvasBg.calcOffset();
      fabricCanvasBg.add(img);
      fabricCanvasBg.add(overlayRect);
      fabricCanvasBg.add(cropRect);
      fabricCanvasBg.centerObject(cropRect);
      cropRect.setCoords();
      fabricCanvasBg.sendToBack(img);
      fabricCanvasBg.bringToFront(cropRect);
      fabricCanvasBg.setActiveObject(cropRect);
      fabricCanvasBg.on('mouse:down', () => {
        fabricCanvasBg.setActiveObject(cropRect);
      });
      let croppedImage;
      let originalImage;
      let rect;
      let croppedCanvas = new fabric.StaticCanvas();

      fabricCanvasBg.on('object:modified', function(e) {
        if (e.target.type === 'crop-rect') {
          let obj = e.target;
          let boundingRect = obj.getBoundingRect(true);
          if (
            boundingRect.left < TOP_LEFT_OFFSET - 2 ||
            boundingRect.top < TOP_LEFT_OFFSET - 2 ||
            boundingRect.left + boundingRect.width >
              obj.canvas.getWidth() - TOP_LEFT_OFFSET + 2 ||
            boundingRect.top + boundingRect.height >
              obj.canvas.getHeight() - TOP_LEFT_OFFSET + 2
          ) {
            obj.top = obj._stateProperties.top;
            obj.left = obj._stateProperties.left;
            obj.angle = obj._stateProperties.angle;
            obj.scaleX = obj._stateProperties.scaleX;
            obj.scaleY = obj._stateProperties.scaleY;
            obj.setCoords();
            obj.saveState();
          }
          fabricCanvasBg.remove(croppedImage);
          fabricCanvasBg.forEachObject(function(o) {
            if (o.type === 'egImage') {
              originalImage = fabric.util.object.clone(o);
              // reset clipPath
              originalImage.clipPath = null;
            }
          });
          rect = fabric.util.object.clone(cropRect);
          rect.set({
            absolutePositioned: true,
            dirty: true,
            objectCaching: false,
          });
          originalImage.dirty = true;
          originalImage.clipPath = rect;
          croppedImage = originalImage;
          fabricCanvasBg.add(croppedImage);
          fabricCanvasBg.bringToFront(croppedImage);
          fabricCanvasBg.bringToFront(cropRect);
          cropRect.saveState();
          fabricCanvasBg.setActiveObject(cropRect);
          fabricCanvasBg.requestRenderAll();
        }
        if (cropRect) {
          fabric.EgImage.fromURL(bg, simulateImg => {
            const scaleX = originalWidth / simulateImg.width;
            const scaleY = originalHeight / simulateImg.height;
            const ratioFactorX = (scaleX / scale) * originalScale;
            const ratioFactorY = (scaleY / scale) * originalScale;
            const finalWidth = cropRect.width * cropRect.scaleX * ratioFactorX;
            const finalHeight =
              cropRect.height * cropRect.scaleY * ratioFactorY;
            simulateImg.set({
              top: 0,
              left: 0,
              scaleX,
              scaleY,
              selectable: false,
              dirty: true,
            });
            croppedCanvas.setWidth(finalWidth);
            croppedCanvas.setHeight(finalHeight);
            croppedCanvas.viewportTransform[4] =
              -(cropRect.left - TOP_LEFT_OFFSET + 1) * ratioFactorX;
            croppedCanvas.viewportTransform[5] =
              -(cropRect.top - TOP_LEFT_OFFSET + 1) * ratioFactorY;
            croppedCanvas.relativePan(new fabric.Point(0, 0));
            croppedCanvas.calcOffset();
            croppedCanvas.add(simulateImg);
            croppedCanvas.requestRenderAll();
            if (isSetAvatar) {
              self.croppedDataUrl = croppedCanvas.toDataURL({
                format: 'jpeg',
              });
            } else {
              $('#preview').attr(
                'src',
                croppedCanvas.toDataURL({
                  format: originalFileType === 'image/jpeg' ? 'jpeg' : 'png',
                  quality: 1.0,
                })
              );
            }
          });
        }
      });
      fabricCanvasBg.fire('object:modified', { target: cropRect });
      fabricCanvasBg.on('object:moving', function(e) {
        let obj = e.target;
        // if object is too big ignore
        if (
          obj.getScaledHeight() > obj.canvas.height ||
          obj.getScaledWidth() > obj.canvas.width
        ) {
          return;
        }
        obj.setCoords();
        // top-left  corner
        if (
          obj.getBoundingRect().top < TOP_LEFT_OFFSET - 1 ||
          obj.getBoundingRect().left < TOP_LEFT_OFFSET - 1
        ) {
          obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
          obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
        }
        // bot-right corner
        if (
          obj.getBoundingRect().top + obj.getBoundingRect().height >
            obj.canvas.height ||
          obj.getBoundingRect().left + obj.getBoundingRect().width >
            obj.canvas.width
        ) {
          obj.top = Math.min(
            obj.top,
            obj.canvas.height -
              obj.getBoundingRect().height +
              obj.top -
              obj.getBoundingRect().top
          );
          obj.left = Math.min(
            obj.left,
            obj.canvas.width -
              obj.getBoundingRect().width +
              obj.left -
              obj.getBoundingRect().left
          );
        }
      });
    });
  };

  this.blobToFile = function(theBlob, fileName) {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };

  this.dataURLtoBlob = function(dataUrl) {
    const parts = dataUrl.split(','),
      mime = parts[0].match(/:(.*?);/)[1];
    if (parts[0].indexOf('base64') !== -1) {
      let bstr = atob(parts[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    } else {
      const raw = decodeURIComponent(parts[1]);
      return new Blob([raw], { type: mime });
    }
  };

  this.readFileImage = function(fabricCanvasBg, file, isSetAvatar = false) {
    let self = this;
    const srcImage = URL.createObjectURL(file);
    const image = new Image();
    image.src = srcImage;
    image.onload = function() {
      self.initCrop(
        fabricCanvasBg,
        srcImage,
        this.width,
        this.height,
        false,
        1,
        isSetAvatar,
        file.type
      );
    };
  };

  this.readFilePDF = function(fabricCanvasBg, file, result) {
    let self = this;
    let fileReader = new FileReader();
    fileReader.onload = function() {
      let pdfData = new Uint8Array(this.result);
      // Using DocumentInitParameters object to load binary data.
      let loadingTask = pdfjs.getDocument({
        data: pdfData,
        cMapUrl: '/static/cmaps/',
        cMapPacked: true,
      });
      loadingTask.promise.then(
        function(pdf) {
          // Fetch the first page
          const DEFAULT_PAGE = 1;
          const RESOLUTION = 2;
          pdf.getPage(DEFAULT_PAGE).then(function(page) {
            let canvas = document.createElement('canvas');
            canvas.id = 'cropperPdf';
            let context = canvas.getContext('2d');
            result.appendChild(canvas);
            const rotation = page.rotate || 0;
            const isPortrait = rotation % 180 === 0;

            const viewport = page.getViewport({ scale: RESOLUTION });
            const originalWidth = isPortrait ? page.view[2] : page.view[3];
            const originalHeight = isPortrait ? page.view[3] : page.view[2];

            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.height = `${originalHeight}px`;
            canvas.style.width = `${originalWidth}px`;

            // Render PDF page into canvas context
            const renderContext = {
              canvasContext: context,
              intent: 'print',
              viewport,
            };
            const renderTask = page.render(renderContext);
            let highResBg = null;
            renderTask.promise
              .then(() => {
                // Convert the canvas to an image to automatically fill it horizontally or vertically
                highResBg = canvas.toDataURL('image/png');

                // Resize canvas to get the image with lower resolution
                canvas.width = originalWidth;
                canvas.height = originalHeight;
                // 画像をrenderするため、下記の2つのscale値で分けます。（scale値が大きいの方は画質が良いです。）
                //・scale= 1→切り抜き画面（モーダル）にrenderするとき利用します。
                //・scale= 2→キャンバス画面にrenderするとき利用します。（現在、対応対象の画面サイズで確認したらscale= 2で良いということ）
                return page.render({
                  ...renderContext,
                  viewport: page.getViewport({ scale: 1 }),
                }).promise;
              })
              .then(() => {
                self.initCrop(
                  fabricCanvasBg,
                  highResBg,
                  viewport.width,
                  viewport.height,
                  canvas.toDataURL('image/png'),
                  RESOLUTION
                );
              });
          });
        },
        function(reason) {
          console.error(reason);
          $('#modal-dialog-preview-bg-image').removeClass('show');
          ui.hideLoaderBg();
          ui.showPopupMessage(messageUtility.getMessage('E-000-021'));
        }
      );
    };
    fileReader.readAsArrayBuffer(file);
  };

  this.getCroppedDataUrl = () => {
    return this.croppedDataUrl;
  };
}

export const cropperImage = new CropperImage();



// WEBPACK FOOTER //
// ./src/canvas/common/crop-image.js